import React, { useEffect, useState } from 'react';
import { Navbar } from '../Navbar';
import { TeacherSidebar } from '../TeacherSidebar';
import { MenuIcon, XIcon, PlusIcon } from 'lucide-react';
export const PayoutsInvoicesPage = () => {
  const [activeTab, setActiveTab] = useState('payouts');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    // Check localStorage for saved preference, default to dark mode
    const savedMode = localStorage.getItem('teacherDashboardTheme');
    return savedMode === 'dark';
  });
  // Toggle sidebar on mobile
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Listen for theme changes from the Navbar component
  useEffect(() => {
    const handleThemeChange = event => {
      setDarkMode(event.detail.darkMode);
    };
    window.addEventListener('themeChange', handleThemeChange);
    return () => {
      window.removeEventListener('themeChange', handleThemeChange);
    };
  }, []);
  // Sample data for Payouts tab
  const payoutsData = [{
    id: 'p001',
    date: 'May 15, 2023',
    amount: '$850.00',
    status: 'Paid'
  }, {
    id: 'p002',
    date: 'April 15, 2023',
    amount: '$780.00',
    status: 'Paid'
  }, {
    id: 'p003',
    date: 'March 15, 2023',
    amount: '$720.00',
    status: 'Paid'
  }, {
    id: 'p004',
    date: 'June 15, 2023',
    amount: '$920.00',
    status: 'Pending'
  }];
  // Sample data for Invoices tab
  const invoicesData = [{
    id: 'INV-2023-0142',
    studentName: 'Emma Johnson',
    amount: '$240.00',
    date: 'May 10, 2023',
    status: 'Sent'
  }, {
    id: 'INV-2023-0128',
    studentName: 'Michael Chen',
    amount: '$180.00',
    date: 'May 3, 2023',
    status: 'Sent'
  }, {
    id: 'INV-2023-0115',
    studentName: 'Sophia Williams',
    amount: '$320.00',
    date: 'April 25, 2023',
    status: 'Sent'
  }, {
    id: 'INV-2023-0096',
    studentName: 'Ethan Parker',
    amount: '$240.00',
    date: 'April 12, 2023',
    status: 'Sent'
  }, {
    id: 'INV-2023-0156',
    studentName: 'Olivia Martinez',
    amount: '$180.00',
    date: 'May 18, 2023',
    status: 'Draft'
  }];
  return <div className={`w-full min-h-screen ${darkMode ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white' : 'bg-gradient-to-r from-gray-50 to-gray-100 text-gray-800'} font-sans transition-colors duration-300`} data-id="element-5863">
      <Navbar setIsDeleteAccountModalOpen={() => {}} data-id="element-5864" />
      <div className="pt-20 pb-16 flex flex-col lg:flex-row" data-id="element-5865">
        {/* Mobile sidebar toggle */}
        <button onClick={toggleSidebar} className="lg:hidden fixed bottom-4 right-4 z-30 bg-deep-pink text-white p-3 rounded-full shadow-lg flex items-center justify-center" aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'} style={{
        minWidth: '56px',
        minHeight: '56px'
      }} data-id="element-5866">
          {isSidebarOpen ? <XIcon className="h-6 w-6" data-id="element-5867" /> : <MenuIcon className="h-6 w-6" data-id="element-5868" />}
        </button>
        {/* Left Sidebar */}
        <aside className={`w-64 fixed inset-y-0 pt-20 pb-16 ${darkMode ? 'bg-navy-900/90 shadow-lg' : 'bg-white shadow-md'} z-20 transform transition-all duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`} data-id="element-5869">
          <TeacherSidebar darkMode={darkMode} closeSidebar={() => setIsSidebarOpen(false)} data-id="element-5870" />
        </aside>
        {/* Main Content */}
        <main className={`flex-1 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-64'} px-4 py-6`} data-id="element-5871">
          <div className="max-w-7xl mx-auto" data-id="element-5872">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6" data-id="element-5873">
              <h1 className={`text-2xl sm:text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5874">
                Payouts & Invoices
              </h1>
            </div>
            {/* Tabs Navigation */}
            <div className="mb-6 border-b border-gray-200 dark:border-navy-700" data-id="element-5875">
              <nav className="flex space-x-8" aria-label="Tabs" data-id="element-5876">
                <button className={`py-4 px-1 text-sm font-medium border-b-2 ${activeTab === 'payouts' ? 'border-deep-pink text-deep-pink' : `border-transparent ${darkMode ? 'text-gray-300' : 'text-gray-500'} hover:text-gray-700 dark:hover:text-gray-200`}`} onClick={() => setActiveTab('payouts')} data-id="element-5877">
                  Payouts
                </button>
                <button className={`py-4 px-1 text-sm font-medium border-b-2 ${activeTab === 'invoices' ? 'border-deep-pink text-deep-pink' : `border-transparent ${darkMode ? 'text-gray-300' : 'text-gray-500'} hover:text-gray-700 dark:hover:text-gray-200`}`} onClick={() => setActiveTab('invoices')} data-id="element-5878">
                  Invoices
                </button>
              </nav>
            </div>
            {/* Tab Content */}
            <div className="mb-6" data-id="element-5879">
              {activeTab === 'payouts' ? <div data-id="element-5880">
                  <div className={`rounded-xl overflow-hidden ${darkMode ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-5881">
                    <div className="overflow-x-auto" data-id="element-5882">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-navy-700" data-id="element-5883">
                        <thead className={`${darkMode ? 'bg-navy-700' : 'bg-gray-50'}`} data-id="element-5884">
                          <tr data-id="element-5885">
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5886">
                              Date
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5887">
                              Amount
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5888">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className={`divide-y divide-gray-200 dark:divide-navy-700 ${darkMode ? 'bg-navy-800' : 'bg-white'}`} data-id="element-5889">
                          {payoutsData.map(payout => <tr key={payout.id} data-id="element-5890">
                              <td className={`px-6 py-4 whitespace-nowrap text-sm ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5891">
                                {payout.date}
                              </td>
                              <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5892">
                                {payout.amount}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-5893">
                                <span className={`px-2.5 py-1 text-xs rounded-full ${payout.status === 'Paid' ? darkMode ? 'bg-green-900/30 text-green-200' : 'bg-green-100 text-green-800' : darkMode ? 'bg-yellow-900/30 text-yellow-200' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-5894">
                                  {payout.status}
                                </span>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> : <div data-id="element-5895">
                  <div className="flex justify-end mb-4" data-id="element-5896">
                    <button className="flex items-center px-4 py-2 bg-deep-pink hover:bg-burgundy text-white rounded-lg transition-colors" data-id="element-5897">
                      <PlusIcon className="h-5 w-5 mr-1" data-id="element-5898" />
                      Create Invoice
                    </button>
                  </div>
                  <div className={`rounded-xl overflow-hidden ${darkMode ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-5899">
                    <div className="overflow-x-auto" data-id="element-5900">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-navy-700" data-id="element-5901">
                        <thead className={`${darkMode ? 'bg-navy-700' : 'bg-gray-50'}`} data-id="element-5902">
                          <tr data-id="element-5903">
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5904">
                              Invoice ID
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5905">
                              Student Name
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5906">
                              Amount
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5907">
                              Date
                            </th>
                            <th scope="col" className={`px-6 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300 uppercase tracking-wider' : 'text-gray-500 uppercase tracking-wider'}`} data-id="element-5908">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className={`divide-y divide-gray-200 dark:divide-navy-700 ${darkMode ? 'bg-navy-800' : 'bg-white'}`} data-id="element-5909">
                          {invoicesData.map(invoice => <tr key={invoice.id} data-id="element-5910">
                              <td className={`px-6 py-4 whitespace-nowrap text-sm ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5911">
                                {invoice.id}
                              </td>
                              <td className={`px-6 py-4 whitespace-nowrap text-sm ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5912">
                                {invoice.studentName}
                              </td>
                              <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5913">
                                {invoice.amount}
                              </td>
                              <td className={`px-6 py-4 whitespace-nowrap text-sm ${darkMode ? 'text-white' : 'text-gray-800'}`} data-id="element-5914">
                                {invoice.date}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap" data-id="element-5915">
                                <span className={`px-2.5 py-1 text-xs rounded-full ${invoice.status === 'Sent' ? darkMode ? 'bg-green-900/30 text-green-200' : 'bg-green-100 text-green-800' : darkMode ? 'bg-blue-900/30 text-blue-200' : 'bg-blue-100 text-blue-800'}`} data-id="element-5916">
                                  {invoice.status}
                                </span>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
        </main>
        {/* Overlay for mobile when sidebar is open */}
        {isSidebarOpen && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-10" onClick={toggleSidebar} aria-hidden="true" data-id="element-5917"></div>}
      </div>
    </div>;
};